export default class ContragentType {
  constructor() {
    this._items = [];
    this._loading = false;
  }

  get() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }

  set({rc, sub}) {
    this._items = [
      {value: 1, label: 'Клиент (физ. лицо)'},
      {value: 2, label: 'Клиент (юр. лицо)'},
      {value: 3, label: 'Оператор'},
      {value: 5, label: 'Партнер/поставщик (физ. лицо)'},
      {value: 6, label: 'Партнер/поставщик (юр. лицо)'},
      ...(rc ? [{value: 7, label: 'Субагент'}] : []),
      ...(sub ? [{value: 7, label: 'Центр бронирования'}] : []),
    ];
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}